import capitalize from 'lodash/capitalize'

// TODO: use a library for methods like these
export const indefiniteArticled = (noun: string) => {
  if (!noun) return noun
  const first = noun.toLowerCase()[0]
  if (['a', 'e', 'i', 'o', 'u'].indexOf(first) >= 0) {
    return `an ${noun}`
  }
  return `a ${noun}`
}

export const createRandomString = () => {
  return Math.random()
    .toString(36)
    .substring(2, 15)
}

export const titleCase = (s: string) =>
  s
    .split(' ')
    .map(word => capitalize(word))
    .join(' ')

export const lastChar = (s: string) => (s.length > 0 ? s[s.length - 1] : '')

export const isNumeric = (s: string) => /^\d+$/.test(s)
